import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import React from 'react';
import {
    Container,
    Thumbnail,
    ThumbnailWrapper
} from './styled';

const MobileMenu = ({
    isOpen,
    onToggle
}) => (
    <Container>
        <ThumbnailWrapper >
            <Thumbnail onClick={ onToggle }>
                {
                    isOpen
                        ?   <MaterialIcon color="white" icon="close" size={ 30 } />
                        :   <MaterialIcon color="white" icon="menu" size={ 32 } />
                }
            </Thumbnail>
        </ThumbnailWrapper>
    </Container>
);

MobileMenu.propTypes = {
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
};

export default MobileMenu;
